exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container-content {\n  width: 100%;\n  display: -ms-flexbox;\n  display: flex; }\n  .container-content ba-checkbox {\n    width: 100%; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Desenvolvimento/PMP/painel/src/app/theme/components/baMultiCheckbox/baMultiCheckbox.scss
// module id = ../../../../../src/app/theme/components/baMultiCheckbox/baMultiCheckbox.scss
// module chunks = 33